/* eslint-disable @typescript-eslint/array-type */
import moment from 'moment-timezone';
import { HasId, FullAuditable, isOnOrAfterDay, isWeekendMoment } from '../common';
import { Channel } from '../channel';
import { Payment } from '../payment';
import { User, UserId } from '../user/User';
import { Location, LocationId } from '../location';
import { Upload } from '../upload';
import { Comment } from '../comment';

export interface SpecialRequest extends HasId, FullAuditable {
    dateRequiredBy: Date | null; // TODO: this should NOT be nullable!
    title: string;
    otherChannels: string | null;
    locationId: LocationId;
    assignedToId: UserId | null;
    statusStep: number;
    quoteCurrency: string;
    quoteAmount: number | null;
    totalPaid: number;

    assignedTo?: User;
    channels: Array<Channel>;
    comments: Array<Comment>;
    location?: Location;
    payments: Array<Payment>;
    uploads?: Array<Upload>;
}

export interface SpecialRequestDto {
    id: number;
    updatedAt: Date;
    createdAt: Date;
    createdById: UserId;

    dateRequiredBy: Date;
    title: string;
    otherChannels: string;
    locationId: LocationId;
    assignedToId: UserId;
    statusStep: number;
    quoteCurrency: string;
    quoteAmount: number;
    totalPaid: number;

    assignedTo?: User;
    channels: Array<Channel>;
    comments: Array<Comment>;
    location?: Location;
}

export interface NewOrUpdateSpecialRequestCommonData {
    statusStep: number;
    dateRequiredBy: Date;
    title: string;
    otherChannels?: string | null;
    channels: { id: number; label: string }[] | number[];
    locationId: LocationId;
    uploads?: Upload[];
}

export interface NewSpecialRequestData extends NewOrUpdateSpecialRequestCommonData {
    brief: string;
}

export interface UpdateSpecialRequestData extends NewOrUpdateSpecialRequestCommonData {
    assignedToId?: UserId;
    comments?: Comment[];
    // eslint-disable-next-line capitalized-comments
    // createdAt? : Date | null;
    id: number;
    quoteAmount?: number;
    quoteCurrency?: string;
    totalPaid?: number;
    // eslint-disable-next-line capitalized-comments
    // updatedAt? : Date | null;
}

export interface AssignSpecialRequestBody {
    userId: UserId;
}

export interface CommentBody {
    userId: UserId;
    comment: string;
    uploads?: Upload[];
    isPrivate: boolean;
}

export interface QuoteBody {
    currency: string;
    amount: number;
    description: string;
}

export function isValidDateForSpecialRequest(date: moment.Moment, createdDate: moment.Moment): boolean {
    return isOnOrAfterDay(date, createdDate) && !isWeekendMoment(date);
}

export function specialRequestHasValidDate(specialRequest: { dateRequiredBy: Date | null; createdAt?: Date }): boolean {

    if (!specialRequest || !specialRequest.dateRequiredBy) {
        return false;
    } else {
        return isValidDateForSpecialRequest(
            moment.utc(specialRequest.dateRequiredBy).local(true),

            moment(specialRequest.createdAt).local(true) || moment(moment.tz.guess()),
        );
    }
}
